import React from 'react'

const Manual_canje_regalos_clau_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Canje de regalos de Clau.io desde Invu
        </h2>
        <iframe
          src="https://scribehow.com/embed/Canje_de_regalos_de_Clau_io_desde_Invu__h_A1J6qhQCycga_hs2thog?as=scrollable"
          className="scribe-iframe-general-68"
          width="100%"
          height="3700"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_canje_regalos_clau_invu
